import React from 'react';
import { Alert, Button } from 'reactstrap';
import PropTypes from 'prop-types';

import './filter_alert.scss';

const FilterAlert = ({ onClick, info }) => (
  <Alert color="danger" className="filter-alert">
    {info}
    <Button className="filter-alert__link " color="link" onClick={onClick}>
      Show me
    </Button>
  </Alert>
);

FilterAlert.propTypes = {
  onClick: PropTypes.func,
  info: PropTypes.string,
};

export default FilterAlert;
